module.exports = __webpack_public_path__ + "assets/images/mozilla-logo-b2559c1a75a74dc0e702c9c8d4f9eeae.png";